import Button from "components/button";
import { DriverFormValues } from "_interfaces/driver.interfaces";
import Input from "components/input";
import PhoneInput from "components/input/phone-input";
import Select from "components/select";
import { NamespaceKeys } from "locale/types";
import { Controller, UseFormReturn } from "react-hook-form";
import DriverAccordion from "./driver-accordion";

interface DriverEmergencyAccordionProps {
  isOpen: boolean;
  onToggle: () => void;
  onNext: () => void;
  form: UseFormReturn<DriverFormValues>;
  t: (key: NamespaceKeys<"driver">, options?: Record<string, unknown>) => string;
}

const DriverEmergencyAccordion = ({
  isOpen,
  onToggle,
  onNext,
  form,
  t,
}: DriverEmergencyAccordionProps) => {
  const {
    register,
    formState: { errors },
  } = form;

  return (
    <DriverAccordion
      title={t("accordion-emergency-contacts")}
      subtitle={t("accordion-emergency-contacts-subtitle")}
      iconName="call-calling"
      isOpen={isOpen}
      onToggle={onToggle}
    >
      <div className="grid grid-cols-1 gap-4">
        <Input
          label={t("label-emergency-contact-name")}
          required
          placeholder={t("placeholder-name")}
          {...register("emergencyName")}
          error={errors.emergencyName}
        />

        <Controller
          name="emergencyRelation"
          control={form.control}
          render={({ field, fieldState }) => (
            <Select
              label={t("label-relation")}
              required
              options={[
                { label: t("relation-mother"), value: "Mother" },
                { label: t("relation-father"), value: "Father" },
                { label: t("relation-spouse"), value: "Spouse" },
                { label: t("relation-son"), value: "Son" },
                { label: t("relation-daughter"), value: "Daughter" },
                { label: t("relation-friend"), value: "Friend" },
              ]}
              value={field.value}
              onValueChange={(value) => field.onChange(value)}
              error={fieldState.error}
              placeholder={t("placeholder-select")}
            />
          )}
        />

        <Controller
          name="emergencyPhoneNumber"
          control={form.control}
          render={({ field, fieldState }) => (
            <PhoneInput
              label={t("label-phone-number")}
              required
              value={field.value}
              onChange={(event) => field.onChange(event.target.value)}
              countryCode={form.watch("emergencyPhoneCountryCode")}
              onCountryChange={(code) => form.setValue("emergencyPhoneCountryCode", code)}
              placeholder={t("placeholder-driver-phone")}
              error={fieldState.error}
            />
          )}
        />
      </div>

      <div className="flex justify-end pt-2">
        <Button type="button" variant="outline" color="tertiary" onClick={onNext}>
          {t("btn-next")}
        </Button>
      </div>
    </DriverAccordion>
  );
};

export default DriverEmergencyAccordion;
